import { Pipe, PipeTransform } from '@angular/core';
import { tryParseJSON } from '../extensions/string.extensions';

@Pipe({
    name: 'beautifyJson',
    pure: false,
    standalone: false,
})
export class BeautifyJsonPipe implements PipeTransform {
    public transform(value: string, isHtml: boolean = false): string {
        if (value !== undefined && value !== null) {
            return this.beautifyJSON(value, isHtml);
        }
    }

    private beautifyJSON(json: string, isHtml: boolean = false): string {
        const parameters = tryParseJSON(json, []);
        const separator = isHtml ? '</br>' : ', ';
        const keys = Object.keys(parameters);
        let result = '';
        keys.forEach((key, index) => {
            const isLastItem = index === keys.length - 1;
            result += `${key}: ${parameters[key]}${isLastItem ? '' : separator}`;
        });
        return result;
    }
}
